export const SRM_SUMMARY_OUTPUT_RULES = `
    This client-facing overview explains framework design, scope, module integration, and remaining assessment work.
    Return readable Markdown headings, paragraphs, and action lists only.
    Keep machine-readable metadata, JSON payloads, and code blocks out of this executive summary.
    Risk scores, confidence metrics, and assessed map locations belong in the specialized assessment reports.
    Describe unfinished assessments as pending. Framework creation does not validate site controls or complete audits.
`;

const metadataStart = /^\{\s*["']?(?:report_metadata|reportMetadata)["']?\s*:/;

export function cleanSrmSummary(summary = ''): string {
    let cleaned = summary.replace(/^([ \t]*)(`{3,}|~{3,})[^\r\n]*\r?\n([\s\S]*?)^\1\2[ \t]*(?:\r?\n|$)/gm,
        (block, _indent, _fence, content: string) => metadataStart.test(content.trim()) ? '' : block);
    const starts = /^[ \t]*\{\s*["']?(?:report_metadata|reportMetadata)["']?\s*:/gm;
    let match: RegExpExecArray | null;
    while ((match = starts.exec(cleaned))) {
        let depth = 0;
        let quote = '';
        let escaped = false;
        for (let i = cleaned.indexOf('{', match.index); i < cleaned.length; i++) {
            const character = cleaned[i];
            if (quote) {
                if (escaped)
                    escaped = false;
                else if (character === '\\')
                    escaped = true;
                else if (character === quote)
                    quote = '';
                continue;
            }
            if (character === '"' || character === "'")
                quote = character;
            else if (character === '{')
                depth++;
            else if (character === '}' && --depth === 0) {
                cleaned = cleaned.slice(0, match.index) + cleaned.slice(i + 1);
                starts.lastIndex = match.index;
                break;
            }
        }
    }
    return cleaned === summary ? summary : cleaned.replace(/(?:\r?\n){3,}/g, '\n\n').trim();
}
